import React, { useState, useEffect } from "react";
import {
  FaFolderOpen,
  FaPaw,
  FaFileInvoice,
  FaHeadset,
  FaComments,
  FaBook,
  FaRegUser,
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import LogoutModal from "../../components/LogoutModal";
import { useProfile } from "../../../context/ProfileContext";
import { clearCredentials } from "../../../../src/features/auth/authSlice";

export const RecordsLayout = () => {
  //const { customerDetails, loader } = useProfile();
  const { loader, displayDetails, isSecondaryUser: isSecUser } = useProfile();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const auth = useSelector((state) => state.auth || {});
   const { secondaryUserInfo } = auth || {};    //new

  const { customer_data, phone } = auth || {};

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  useEffect(() => {
    const handleToggleSidebar = () => {
      setIsSidebarOpen((prev) => !prev);
    };

    window.addEventListener("toggleRecordsSidebar", handleToggleSidebar);
    return () =>
      window.removeEventListener("toggleRecordsSidebar", handleToggleSidebar);
  }, []);

  const tabs = [
    { name: "Profile", icon: <FaRegUser />, path: "/records/profile" },
    { name: "My Bookings", icon: <FaFolderOpen />, path: "/records/bookings" },
    { name: "My Pets", icon: <FaPaw />, path: "/records/pets" },
    { name: "Diary", icon: <FaBook />, path: "/records/diary" },
    // { name: "Invoice", icon: <FaFileInvoice />, path: "/records/invoice" },
    { name: "Chats", icon: <FaComments />, path: "/records/chats" },
    { name: "Contact Us", icon: <FaHeadset />, path: "/records/contact" },
    
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("phone");
    dispatch(clearCredentials());
    setIsLogoutModalOpen(false);
    navigate("/");
  };

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  // Get display name - use displayDetails
  const getDisplayName = () => {
    if (loader) return "Loading...";
    if (isSecUser && displayDetails) {
      return displayDetails.name || secondaryUserInfo?.name || "Secondary User";
    }
    return displayDetails?.name || "User";
  };

  // Get display phone
  const getDisplayPhone = () => {
    if (loader) return "XXXXXXXXXX";
    if (isSecUser && displayDetails) {
      return displayDetails.phone || secondaryUserInfo?.phone || "XXXXXXXXXX";
    }
    return displayDetails?.phone || "XXXXXXXXXX";
  };

  // Get avatar initial
  const getAvatarInitial = () => {
    if (loader) return "...";
    const name = getDisplayName();
    return name?.[0]?.toUpperCase() || "U";
  };


  return (
    <>
      <div className="flex min-h-screen font-[Inter] bg-gray-100 overflow-x-hidden">
        {/* Mobile Overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <aside
          className={`
            w-72 bg-gradient-to-b from-[#0F172A] via-[#1E3A8A] to-[#2563EB]
            shadow-2xl flex flex-col
            ${
              isSidebarOpen
                ? "fixed inset-y-0 left-0 z-40 translate-x-0"
                : "fixed -translate-x-full lg:translate-x-0"
            }
            lg:left-0 lg:top-[88px] lg:h-[calc(100vh-88px)] lg:z-30
            transition-transform duration-300
          `}
        >
          {/* Profile */}
          <div className="flex items-center gap-3 px-4 py-4">
            {/* Profile */}
            <div className="flex items-center gap-3">
              <div className="bg-white/20 w-10 h-10 rounded-full flex items-center justify-center text-white text-xl font-bold">
                {
                  getAvatarInitial()
               // loader
                 // ? "..."
                 // : (customerDetails?.firstname || customerDetails?.firstName)?.[0]?.toUpperCase() || "U"
                  }
              </div>
              <div>
                <h1 className="font-semibold text-white text-lg">
                  { getDisplayName()
                  //loader
                   // ? "Loading..."
                   // : `${customerDetails?.firstname || customerDetails?.firstName || ""} ${
                    //    customerDetails?.lastname || customerDetails?.lastName || ""
                    //  }`.trim() || "User"
                      }
                </h1>
                <p className="text-orange-100 text-xs">
                  +91{" "}
                  {
                    getDisplayPhone()
                  //loader
                  //  ? "XXXXXXXXXX"
                   // : customerDetails?.contact || "XXXXXXXXXX"
                    }
                </p>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <nav className="flex-1 overflow-y-auto px-4">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => {
                  navigate(tab.path);
                  setIsSidebarOpen(false);
                }}
                className={`w-full flex items-center gap-4 px-6 py-4 mb-2 rounded-lg transition
                  ${
                    isActiveRoute(tab.path)
                      ? "bg-white text-[#FF6216] font-bold"
                      : "text-orange-50 hover:bg-white/10"
                  }`}
              >
                <span className="text-xl">{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </nav>

          {/* Logout */}
          <div className="p-6 border-t border-white/20">
            <button
              onClick={() => setIsLogoutModalOpen(true)}
              className="w-full py-3 rounded-xl bg-white/10 hover:bg-red-600 text-white"
            >
              Logout
            </button>
          </div>
        </aside>

        {/* Content */}
        <main className="flex-1 min-w-0 w-full p-0 sm:p-2 overflow-x-hidden lg:ml-72">
          <div className="w-full bg-white sm:rounded-2xl sm:shadow-lg overflow-x-hidden">
            <Outlet />
          </div>
        </main>
      </div>

      <LogoutModal
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        onLogout={handleLogout}
      />
    </>
  );
};
